import axios from 'axios'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { API_URL } from 'src/cms/constants/EndPoint'
import { actions } from './redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import * as auth from './redux/actions'
import { actionTypes } from './redux/constants'
import AuthService from 'src/cms/constants/authService'

const Callback = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const queryParams = new URLSearchParams(location.search)
  const code = queryParams.get('code')
  const state = queryParams.get('state')
  const iss = queryParams.get('iss')
  const stateKey = `oidc.${state}`
  const stateObj = JSON.parse(sessionStorage.getItem(stateKey) || '{}')
  const authResp = useSelector((state: any) => state.auth)
  const code_verifier = stateObj.code_verifier
  const redirect_url = window.__RUNTIME_CONFIG__.REACT_APP_REDIRECT_URL
  const authService = new AuthService()
  const payload = {
    code,
    state,
    iss,
    code_verifier,
    redirect_url,
  }
  useEffect(() => {
    axios
      .post(`${API_URL}/sso/login`, payload)
      .then(async (res) => {
        try {
          const token = res?.data?.data?.token
          await dispatch({ type: actionTypes.LOGIN_SUCCESS, payload: { accessToken: token } })
          // await dispatch(auth.actions.requestUser(token))
          history.push('/dashboard')
        } catch (error) {
          console.error('Login error:', error)
          // await authService.logout()
          dispatch(auth.actions.logout())
        }
      })
      .catch((err) => {
        console.error('Login error:', err)
        // authService.logout()
        dispatch(auth.actions.logout())
      })
  }, [])

  return <></>
}

export default Callback
